
import React from 'react';
import moment from 'moment';
import {
  List, Grid, ListItem, ListItemText, DialogTitle,
  Dialog, DialogActions, Button, Menu, MenuItem,
  DialogContent, Typography, makeStyles, TableBody, TableCell, Avatar, TableHead, TableRow, Table
} from '@material-ui/core';

import KenColors from '../../../Utils/themes/KenColors';
import { useTranslation } from 'react-i18next';
import KenInputField from "../../../global_components/KenInputField";
import KenButton from "../../../global_components/KenButton";
import KenTable from "../../../global_components/KenTable";
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import { eventDateFormate } from '../../../Utils/constants';


const useStyles = makeStyles((theme) => ({
  eventTitle: {
    background: KenColors.eventTitleBackgroundColor,
    padding: 10,
    fontWeight: 600,
    color: KenColors.eventTitleColor
  },

  editorBox: {
    overflow: "auto",
    height: "200px"

  }

}));

const ParticipantModal = ({ openParticipantModal, setOpenParticipantModal, subList, eventDetails }) => {

  const classes = useStyles();
  const { t } = useTranslation();
  const [dense, setDense] = React.useState(false);


  const handleClose = () => {
    setOpenParticipantModal(false);
  };
  const getName = (name) => {
    const initials = name.charAt(0);
    return initials;

  }
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <Dialog className="participantmodal" open={openParticipantModal} onClose={handleClose} maxWidth="md" fullWidth={true} aria-labelledby="form-dialog-title" >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        Participant Lists
        </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <Typography variant="h5" component="h5" color="primary">
              {eventDetails.Subject}
            </Typography>
            <Typography variant="body1" gutterBottom>
              {subList.length + " " + t("headings:Attendance")}
            </Typography>
            <Typography variant="body2" gutterBottom>
              {t("labels:from")} : <span>{moment(eventDetails.StartDateTime).format(eventDateFormate)} </span> {t("labels:to")} : <span>{moment(eventDetails.EndDateTime).format(eventDateFormate)}</span>      </Typography>
          </Grid>
          <Grid item xs={2}>
            {/* <Button className="share" variant="outlined" color="primary" startIcon={<ShareOutlinedIcon />} aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
              {t("labels:Share")}
            </Button> */}
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
            >
              <MenuItem onClick={handleCloseMenu}><EmailOutlinedIcon /> <span>{t("labels:Share_via_Email")}</span></MenuItem>
              <MenuItem onClick={handleCloseMenu}><FileCopyOutlinedIcon /> <span>{t("labels:Copy_link")}</span></MenuItem>
            </Menu>
          </Grid>
          <Grid item xs={2}>
            {/* <Button className="export" variant="outlined" color="primary" startIcon={<ShareOutlinedIcon />} aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
              {t("labels:Export")}
            </Button> */}
            <Menu
              id="simplemenu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
            >
              <MenuItem onClick={handleCloseMenu}><EmailOutlinedIcon /> <span>{t("labels:Excel_Format")}</span></MenuItem>
              <MenuItem onClick={handleCloseMenu}><FileCopyOutlinedIcon /> <span>{t("labels:PDF_Format")}</span></MenuItem>
              <MenuItem onClick={handleCloseMenu}><FileCopyOutlinedIcon /> <span>{t("labels:CSV_Format")}</span></MenuItem>
            </Menu>
          </Grid>
        </Grid>
      
      <div className="scroll-content">
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>{t("labels:Attendee_Name")}</TableCell>
              <TableCell>{t("labels:Contact_Number")}</TableCell>
              <TableCell>{t("labels:Email_id")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {subList.length > 0 && subList.map((list) => {
              return (
                <TableRow>
                  <TableCell> <Avatar>{getName(list.Name)}</Avatar> <Typography variant="body1" color="primary">
                    {list.Name}
                  </Typography>
                  </TableCell>
                  {(list.mobile != undefined) ? <TableCell>{list.mobile}</TableCell> : <TableCell>---</TableCell> }
                  { (typeof list.email === 'string' ) ? <TableCell>{list.email}</TableCell> : <TableCell>---</TableCell>}
                </TableRow>
              )
            })}
          </TableBody>
        </Table>

      </div>
          
      </DialogContent>


      <DialogActions className="mr-2">
        <KenButton variant="outlined" onClick={handleClose} >
          {t("labels:cancel")}
        </KenButton>
      </DialogActions>


    </Dialog>
  );

}

export default ParticipantModal;